import { UserID } from "../../redux/interfaces/user.types.ts";

/**
 * MB-379 — ¿este usuario puede renovar expedientes?
 *
 * Replica EXACTAMENTE `IsAdminUser` del backend de multiexpediente, que es
 * `is_superuser or is_staff or pertenece al grupo "admin"`. Vive aquí, con nombre, y no
 * suelto dentro de un componente, porque la regla tiene que poder compararse de un vistazo
 * con la del servidor: cuando se escribió sólo en el componente, miraba únicamente el grupo
 * y un superusuario sin él no veía el botón aunque la API le dejaba renovar.
 *
 * Los dos campos son opcionales a propósito: una sesión abierta antes de que el perfil los
 * expusiera no los trae, y en ese caso la regla se degrada sola a mirar el grupo, que es el
 * comportamiento anterior y el lado seguro.
 */
export const isRenewalAdmin = (
  userInfo: Pick<UserID, "groups" | "is_staff" | "is_superuser"> | null | undefined,
): boolean =>
  !!userInfo &&
  (userInfo.groups?.includes("admin") || !!userInfo.is_staff || !!userInfo.is_superuser);
